/** @jsxImportSource @emotion/react */
import React, { Fragment, useMemo, useState } from 'react'
import {
  Column,
  TableInstance,
  useAsyncDebounce,
  useGlobalFilter,
  useSortBy,
  useTable,
} from 'react-table'
import {BaseInput, Text} from '../../atoms'
import * as styles from './index.styles'
import {useNavigate} from "react-router-dom";
import { DeleteIcon, EditIcon } from '../../../assets'
import { Modal } from '../../../components/templates'
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {delete_management} from "../../../redux/actions/management/delete_management";
import {management} from "../../../redux/actions/management/management";

export type Props = {
  columns: Column<any>[]
  data: any[]
}

const FilterInput = ({
  globalFilter,
  setGlobalFilter,
}: Pick<TableInstance, 'globalFilter' | 'setGlobalFilter'>) => {
  const [filter, setFilter] = useState<string>(globalFilter)
  const onFilterChange = useAsyncDebounce(
    (value) => setGlobalFilter(value || undefined),
    200
  )

  const handleChange = (value: string) => {
    setFilter(value)
    onFilterChange(value)
  }
  return (
    <BaseInput
      style={styles.search}
      name="search"
      value={filter}
      placeholder="Buscar"
      onChange={handleChange}
    />
  )
}

const TableBaseFCM: React.FC<Props> = ({
  columns: columnsTable,
  data: dataTable,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const token = useSelector((state: any) => state.login.access)

  const columns = useMemo((): Column<any>[] => columnsTable, [columnsTable])
  const data = useMemo((): any[] => dataTable, [dataTable])
  const tabla = useTable({ columns, data }, useGlobalFilter, useSortBy)
  const [show, setShow] = useState(false)
  const [idData, setIdData] = useState({id: 0, type: ''})
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    state: { globalFilter },
  } = tabla

  // const [filter, setFilter] = useState<Option | undefined>(undefined)
  const handleDirectManagementE = (row: any) => {
    navigate(`/app/edit-managements/${row.original.id}`)
  }
  const handleDirectDelete = (row: any, action: string) => {
    setShow(true)
    setIdData({id:row.original.id, type: action})
  }
  const actionDelete = (data: any) => {
    let id = data.id
    switch(data.type) {
      case 'Management':
        dispatch(delete_management({ token, id }))
        //navigate(`/app/dashboard`)
        setTimeout(() => {
          dispatch(management({token}));
        }, 1500)
        break;
      default:
        // code block
    }
    toast.success('Eliminación exitosa!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    })
    setShow(false)
  }

  return (
    <Fragment>
      <Modal
          show={show}
          text=""
          title="¿Esta seguro que desea eliminar?"
          btnSuccess="Cancelar"
          btnWarning="Eliminar"
          onClickWarning={() => {actionDelete(idData)}}
          onClickSuccess={() => {setShow(false)}}
          onClickClose={() => {setShow(false)}}
      />

      <div css={styles.actions}>
        <FilterInput
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
      </div>
      <table {...getTableProps()} css={styles.table}>
        <thead css={styles.tableHeader}>
          {headerGroups.map((headerGroup, index) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              css={styles.tableHeaderRow}
              key={`tr-${index}`}
            >
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  css={styles.tableHeaderCell}
                  key={`th-${column.render('Header')}`}
                >
                  {column.render('Header')}
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      <span> &darr;</span>
                    ) : (
                      <span> &uarr;</span>
                    )
                  ) : (
                    ''
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} css={styles.tableBody}>
          {rows.map((row) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()} css={styles.tableBodyRow}>
                {row.cells.map((cell) => {
                    return (
                        <td {...cell.getCellProps()} css={styles.tableBodyCell}>
                          {cell.render('Cell')}
                          {cell.column.id === 'active' ? cell.value === true ? 'Activo' : 'Inactivo' : null}
                          {cell.column.id === 'editManagement' ? <EditIcon width={24} height={24} css={styles.icon} onClick={() => handleDirectManagementE(row)} /> : null}
                          {cell.column.id === 'deleteManagement' ? <DeleteIcon width={24} height={24} css={styles.icon} onClick={() => handleDirectDelete(row, 'Management')} /> : null}
                        </td>
                    )
                })}
              </tr>
            )
          })}
        </tbody>
        <Text textType="sm">{rows.length===0?'No hay datos en la tabla.':''}</Text>
      </table>
    </Fragment>
  )
}

export default TableBaseFCM
